import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const SimuladorCreditoEmpreendimentoParametroService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'simulador-credito-empreendimento-parametro/excel/deletar', 'excelSimuladorCreditoEmpreendimentoParametroDeletar');
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'simulador-credito-empreendimento-parametro/excel', 'excelSimuladorCreditoEmpreendimentoParametro');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('simulador-credito-empreendimento-parametro/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('simulador-credito-empreendimento-parametro/eventGrid', {});
    }
}

export default SimuladorCreditoEmpreendimentoParametroService;